import axios from "axios";
import * as API_LINKS from '../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_TRACK_AND_TRACE = 'FETCH_TRACK_AND_TRACE'
export const RECEIVE_TRACK_AND_TRACE = 'RECEIVE_TRACK_AND_TRACE'
export const FAILED_TRACK_AND_TRACE = 'FAILED_TRACK_AND_TRACE'


export function fetchTnTList(token, id_linked_do){

    return async (dispatch, getState) => {
        dispatch({type: FETCH_TRACK_AND_TRACE});
        axios({
            method: 'post',
            url: API_LINKS.TRACK_AND_TRACE_SHARE_URL,
            data:{
                id_linked_do,
                // token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZF9saW5rZWRfZG8iOiIyIiwiaWRfY29tcGFueSI6MSwiaWF0IjoxNjk4NDAzMTUxLCJleHAiOjIwMTM3NjMxNTF9.7QK95mw5qi0jDKzmlQXp8knv_Ep0vQH6bnFdN24Lo7s"
            }
        })
        .then((response) => {
            const tntSharedObj = {
                timeline: [],
                current: {},
                upNext: [],
                history: [],
                otherThanCurrentWo: [],
                currentDoDetail: null
            }
            const currentIDDO = response.data.current_do.id_delivery_order
            let isCurrentDoIdFound = false
            tntSharedObj.current = response.data.current_do
            tntSharedObj.timeline = response.data.do_linked_list
            tntSharedObj.currentDoDetail = response.data.result
            response.data.do_linked_list.forEach(item => {
                if(item.id_delivery_order !== currentIDDO){
                    tntSharedObj.otherThanCurrentWo.push(...item.workOrders)
                }
                if(item.id_delivery_order === currentIDDO){
                    isCurrentDoIdFound = true
                    item.status = "CURRENT"
                    return
                }
                if(isCurrentDoIdFound){
                    item.status = "PLANNED"
                    tntSharedObj.upNext.push(item)
                }
                if(!isCurrentDoIdFound){
                    item.status = "FINISHED"
                    tntSharedObj.history.push(item)
                }
            })
            response.data = tntSharedObj
            dispatch( {
                type: RECEIVE_TRACK_AND_TRACE,
                payload: response.data,
            })
        })
        .catch(function(error){
            console.log(error)
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_TRACK_AND_TRACE
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_TRACK_AND_TRACE
                    })
                    return toast.error("Failed in fetching Work Orders List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_TRACK_AND_TRACE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_TRACK_AND_TRACE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_TRACK_AND_TRACE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_TRACK_AND_TRACE
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/aTransporter-TrackAndTrace.jsx